import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AmbitService } from '../ambit.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public menuTabs: any = {};
  public activeMenu: string = '';

  constructor(private router: Router,
    public service: AmbitService) {
    if (!localStorage.getItem('AmbitUser')) {
      this.router.navigate(['/login']);
    }
  }

  ngOnInit() {
    var activePage = this.router.url;
    this.menuTabs = {};
    this.activeMenu = '';
    if (activePage == '/users' || activePage == '/drivers') {
      this.menuTabs.tab1 = true;
    }
    if (activePage == '/cities' || activePage == '/stops') {
      this.menuTabs.tab2 = true;
    }
    if (activePage == '/cars-categories' || activePage == '/cars') {
      this.menuTabs.tab3 = true;
    }
    if (activePage == '/settings' || activePage == '/login') {
      this.menuTabs.tab4 = true;
    }
    // if (activePage == '/trips' ) {
    //   this.menuTabs.tab4 = true;
    // }
    // if (activePage == '/payments' ) {
    //   this.menuTabs.tab5 = true;
    // }
    this.activeMenu = activePage;
  }

  logOut() {
    this.service.adminUser = '';
    localStorage.removeItem('AmbitUser');
    this.router.navigate(['/login']);
  }

  getActiveMedia(tab) {
    var dropdown = document.getElementById('mediaMenuDropdown');
    dropdown.classList.add('d-none');
    setTimeout(() => {
      dropdown.classList.remove('d-none');
    }, 100);
    // this.service.activeMedia = tab;
  }

  getCount() {
    var count = 0;
    count = (this.service.driverRequestsList.length || 0) + (this.service.pendigCarsCount || 0) +
      (this.service.pendigPayoutsCount || 0) + (this.service.pendigTicketsCount || 0);
    return count;
  }

  getRequestCount() {
    var count = 0;
    count = (this.service.driverRequestsList.length || 0) + (this.service.pendigCarsCount || 0) ;
    return count;
  }

}
